import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router';
import { fetchStorageSite, fetchStorageSiteRoundReports } from 'actions/storageSites';
import { useDispatch } from 'react-redux';
import strings from 'localization/strings';
import { handleResponse } from 'actions/actionHelpers';
import routes from 'routes';
import { useScrollToTop } from 'helpers/BrowserHelper';

import Loader from 'common/Loader';
import PageTitle from 'common/PageTitle';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import ShortDateTime from 'common/ShortDateTime';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { Link } from 'react-router-dom';

const StorageSiteRoundReports = () => {
    const dispatch = useDispatch();
    const params = useParams();

    const [isLoading, setIsLoading] = useState(true);
    const [storageSite, setStorageSite] = useState(undefined);
    const [roundReports, setRoundReports] = useState(undefined);
    const storageSiteId = params.storageSiteId;

    useEffect(() => {
        setIsLoading(true);
        dispatch(fetchStorageSite(storageSiteId))
            .then(handleResponse(
                response1 => {
                    setStorageSite(response1.payload);
                    dispatch(fetchStorageSiteRoundReports(storageSiteId))
                        .then(handleResponse(
                            response2 => {
                                setRoundReports(response2.payload);
                                setIsLoading(false);
                            },
                            () => setIsLoading(false)
                        ));
                },
                () => setIsLoading(false)
            ));
    }, [storageSiteId]);

    useScrollToTop();

    const title = strings.formatString(strings.roundReportsForX, (storageSite?.title) ?? storageSiteId);

    const getRoundReportUrl = roundReport => routes.roundReport.replace(':roundReportId', roundReport.id).replace(':token', roundReport.token);

    return (
        <>
            <PageTitle>{title}</PageTitle>
            <Box>
                { isLoading && <Loader /> }
                { !isLoading && <Typography variant="h2" gutterBottom>{title}</Typography> }
                {
                    !isLoading && roundReports && roundReports.length === 0 &&
                    (
                        <Typography variant="body1">
                            {strings.noRoundReports}
                        </Typography>
                    )
                }
                {
                    !isLoading && roundReports && roundReports.length > 0 &&
                    (
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>{strings.created}</TableCell>
                                    <TableCell>{strings.markedAsCompleted}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    roundReports.map(roundReport => (
                                        <TableRow key={roundReport.id}>
                                            <TableCell>
                                                <Link to={getRoundReportUrl(roundReport)} target="_blank"><ShortDateTime value={roundReport.createdTime}/></Link>
                                            </TableCell>
                                            <TableCell>
                                                { roundReport.completedTime && <ShortDateTime value={roundReport.completedTime}/> }
                                            </TableCell>
                                        </TableRow>
                                    ))
                                }
                            </TableBody>
                        </Table>
                    )
                }
            </Box>
        </>
    );
};

export default StorageSiteRoundReports;
